import React, { lazy, useEffect, useMemo } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { useLocation } from "react-router-dom";

import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import WalletModal from "./components/Popups/WalletModal";
import { chains } from "./utils/Chains"

import { store, persister, useSelector, dispatch } from "./store";

//walletconnect
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { WagmiConfig } from 'wagmi'

//phantom
import {
  PhantomWalletAdapter
} from "@solana/wallet-adapter-wallets";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { initFlowbite } from "flowbite";
import { APIProvider } from "./context/ApiContext";
import AuthLayout from "./layout/authoLayout";
import { Toaster } from "react-hot-toast";
import io from "socket.io-client";
import { ChangePage } from "./store/reducers/menu";
import { authenticateSockets } from "./utils/socket";
import { Logout, SetBetsId, SetCode, UpdateBalance, UpdateToken, UpdateCrashInfo, UpdateMineInfo, UpdateOriginalGamesList } from "./store/reducers/auth";
import { BASE_SOCKET_URL } from "./config";
import WebApp from '@twa-dev/sdk';
import LoadingOverlay from "./components/Loader/LoadingOverlay";

require("@solana/wallet-adapter-react-ui/styles.css");

const Layout = lazy(() => import("./containers/Layout"));
require("flowbite/dist/flowbite.js");

//walletconnect config
const projectId = 'a1e18847cf6240e83226b37dabb8d6da'
const metadata = {
  name: 'BCB',
  description: 'BCB wallet',
  url: 'https://blockchainbets.club',
  icons: ['https://s2.coinmarketcap.com/static/img/coins/64x64/23165.png']
}
const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })
createWeb3Modal({ wagmiConfig, projectId, chains })

//phantom config
const Endpoint = "https://solana-mainnet.g.alchemy.com/v2/YINfgAjc9p6WnRm2hH2VPqT-u64RVggF";

function App() {


  const { isLoggedIn, balance, token, user } = useSelector((state) => state.auth);
  const { pathname } = useLocation();

  const Wallets = useMemo(
    () => [
      new PhantomWalletAdapter()
    ],
    [Endpoint]
  );

  useEffect(() => {
    let socket = io(BASE_SOCKET_URL);
    if (isLoggedIn) {
      socket = io(BASE_SOCKET_URL, { query: { auth: token } });
      authenticateSockets(user._id);
      socket.on("logout", () => {
        dispatch(Logout({}));
      });
      socket.on("reload", () => {
        window.location.reload();
      });
      socket.on("balance", (data) => {
        if (!isLoggedIn) return;
        if (data.balance !== balance) {
          dispatch(UpdateBalance(data.balance));
        }
      });
      socket.on("updateToken", (data) => {
        if (!isLoggedIn) return;
        dispatch(UpdateToken(data.token))
      })
      socket.on("msg sends", (data) => { });

      socket.on("crash-info", (data) => {
        dispatch(UpdateCrashInfo(data?.data))
      });

      socket.on("mine-info", (data) => {
        dispatch(UpdateMineInfo(data));
      });

      socket.on("updateOriginalGames", (data) => {
        if (data?.data) {
          dispatch(UpdateOriginalGamesList(data?.data));
        }
      });

    }
    return () => {
      if (socket) {
        socket.off("logout");
        socket.off("reload");
        socket.off("balance");
        socket.off("msg sends");
        socket.off("crash-info");
      }
    };
  }, [token, balance, isLoggedIn, user, dispatch]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const c = params.get("c");
    if (c) {
      dispatch(SetCode(c));
      dispatch(ChangePage("register"));
    }
    const b = params.get("b");
    if (b) {
      dispatch(SetBetsId(b));
      dispatch(ChangePage("bets"));
    }
  }, [pathname, dispatch]);

  useEffect(() => {
    setTimeout(() => {
      initFlowbite();
    }, 2000);
  }, []);

  return (
    <WagmiConfig config={wagmiConfig}>
      <ConnectionProvider endpoint={Endpoint}>
        <WalletProvider wallets={Wallets} autoConnect>
          <WalletModalProvider>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persister}>
                <APIProvider>
                  <LoadingOverlay />
                  <AuthLayout />
                  <AccessibleNavigationAnnouncer />
                  <Switch>
                    {/* Place new routes over this */}
                    <Route index path="/app" component={Layout} />
                    {/* If you have an index page, you can remothis Redirect */}
                    <Redirect exact from="/" to="/app/home" />
                  </Switch>
                  <Toaster
                    position="top-right"
                    reverseOrder={false}
                  />
                </APIProvider>
              </PersistGate>
            </Provider>
          </WalletModalProvider>
        </WalletProvider>
      </ConnectionProvider>
    </WagmiConfig>
  );
}

export default App;
